var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/Returned"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250853",
    d: "M18.2936 16.1431L13.7102 17.8802C12.8485 18.2068 12.2785 19.0323 12.2785 19.9539C12.2785 21.54 13.8951 22.6133 15.3569 21.9978L19.8742 20.0955C20.6635 19.7631 21.1768 18.99 21.1768 18.1336C21.1768 16.6442 19.6864 15.6152 18.2936 16.1431Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250842",
    d: "M2.82353 8.13468L11.9146 12.2462M2.82353 8.13468V19.7789L11.9146 23.2941M2.82353 8.13468L4.09628 7.4128M11.9146 12.2462L21.0057 8.13468M11.9146 12.2462V23.2941M21.0057 8.13468V19.7789L11.9146 23.2941M21.0057 8.13468L17.7329 6.69092",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008927"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1016",
    cx: 11.6863,
    cy: 5.33335,
    r: 4.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1017",
    d: "M13.4363 1.00591C12.8959 0.787149 12.3052 0.666687 11.6863 0.666687C9.10898 0.666687 7.01964 2.75602 7.01964 5.33335C7.01964 7.91068 9.10898 10 11.6863 10C14.2636 10 16.353 7.91068 16.353 5.33335C16.353 5.1358 16.3407 4.94112 16.3169 4.75002",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250835",
    d: "M9.83596 4.01745L12.1217 6.12045L16.3666 1.57553",
    stroke: "#383434",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturned);
export default __webpack_public_path__ + "static/media/Returned.33b43bdd411c7d417f93c9463e6faf5e.svg";
export { ForwardRef as ReactComponent };